import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M105.589 35.336a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#ACB8C3"
      d="M32.63 23.768a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M5.5 59a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M102.931 69.433a1.5 1.5 0 0 1 0 2.12l-9.993 9.994a1.5 1.5 0 1 1-2.122-2.121l9.993-9.993a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M90.816 69.433a1.5 1.5 0 0 1 2.122 0l9.993 9.992a1.501 1.501 0 0 1-2.122 2.122l-9.993-9.993a1.5 1.5 0 0 1 0-2.121M13.133 17.268a1.5 1.5 0 0 1 1.5 1.5V32.9a1.5 1.5 0 0 1-3 0V18.768a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M4.566 25.834a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 1 1 0 3H6.066a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#7B8493"
      fillRule="evenodd"
      d="M60.972 63.786a2.25 2.25 0 0 1 0 3.182L49.591 78.349h12.835a2.25 2.25 0 0 1 1.591 3.84L45.75 100.458a2.25 2.25 0 1 1-3.182-3.182l14.426-14.426H44.159a2.25 2.25 0 0 1-1.591-3.841L57.79 63.786a2.25 2.25 0 0 1 3.182 0"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      d="M67.634 22.525c-9.952 0-18.493 6.002-22.228 14.58a18.35 18.35 0 0 0-10.052-2.992c-10.189 0-18.449 8.26-18.449 18.45 0 6.538 3.411 12.268 8.542 15.544a14.2 14.2 0 0 0 8.611 2.903h30.699q.73 0 1.439-.073c.479.03.954.073 1.439.073 13.389 0 24.242-10.854 24.242-24.242S81.023 22.525 67.634 22.525"
    />
    <path
      fill="#ACB8C3"
      d="M35.434 92.201a4 4 0 1 1-8 0 4 4 0 0 1 8 0M60.434 103.201a4 4 0 1 1-8 0 4 4 0 0 1 8 0M75.434 92.201a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
    />
  </svg>
);
const SvgEnrichedIconExtremeWeatherGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconExtremeWeatherGreyscale);
export default Memo;
